import { parse } from '../../util/urlHelpers';
import { verificationStarted, verify } from '../../ducks/emailVerification.duck';

// ================ Load data ================ //

export const loadData = (params, search) => dispatch => {
  const urlParams = parse(search);
  const tokenHash = urlParams.token_hash || null;
  if (!tokenHash) return Promise.resolve();

  // The flow is the route, not a URL param; each route injects its otpType.
  const type = params?.otpType || 'signup';

  // Seed the verifying state on the server too, so the first paint is the
  // spinner rather than a placeholder the client immediately replaces.
  dispatch(verificationStarted(type));

  // The request itself is browser-only: it needs the PKCE code-verifier cookie
  // to decide whether this browser stays logged in.
  if (typeof window === 'undefined') return Promise.resolve();

  return dispatch(verify({ tokenHash, type }));
};
